import { ConsignmentState } from '../../../utils/consignmentState'
import { today } from '../../../utils/dateTime'

export interface SearchParams {
  searchPhrase?: string
  searchOperator?: SearchOperator
  customers?: number[]
  states?: string[]
  dateOption?: DatePeriods
  fromDate?: string
  toDate?: string
  advancedFilter?: AdvancedFilterJson
  orderStatus?: OrderStatus
}

export type DatePeriods =
  | typeof NO_DATE
  | typeof WITHOUT_DELIVERY_DATE
  | 'TODAY'
  | 'YESTERDAY'
  | 'TOMORROW'
  | 'LAST30'
  | 'PLUS_MINUS_15'
  | 'PLUS_MINUS_30'
  | typeof CUSTOM_DATE

export type SearchOperator = 'AND' | 'OR'

export const ACTIVE_ORDERS = 'ACTIVE'
export const DELETED_ORDERS = 'DELETED'

export type OrderStatus = typeof ACTIVE_ORDERS | typeof DELETED_ORDERS

export const isDeletedOrdersSearch = (orderStatus: OrderStatus | undefined) => orderStatus === DELETED_ORDERS

export const parseOrderStatus = (param: string | null): OrderStatus =>
  param === DELETED_ORDERS ? DELETED_ORDERS : ACTIVE_ORDERS

export interface AdvancedFilter {
  type: string
  condition: 'INCLUDE' | 'EXCLUDE'
  searchTerm: string
}

export const CUSTOM_DATE = 'CUSTOM_DATE'
export const NO_DATE = 'NO_DATE'
export const WITHOUT_DELIVERY_DATE = 'WITHOUT_DELIVERY_DATE'

export const isDateRangeOption = (date: string) => date !== NO_DATE && date !== WITHOUT_DELIVERY_DATE

export const SEARCHABLE_STATES = [
  ConsignmentState.CREATED,
  ConsignmentState.UNCONFIRMED,
  ConsignmentState.RESOLVED,
  ConsignmentState.UNRESOLVED,
  ConsignmentState.OFFERED,
  ConsignmentState.ASSIGNED,
  ConsignmentState.COLLECTED,
  ConsignmentState.DEVIATED,
  ConsignmentState.DELIVERED,
  ConsignmentState.RETURNED,
  ConsignmentState.REJECTED,
  ConsignmentState.REFUSED
]

export interface ShipmentFormValues {
  searchPhrase: string
  searchOperator: SearchOperator
  customers: number[]
  orderStatus: OrderStatus
  states: string[]
  date: DatePeriods
  advancedFilters: AdvancedFilter[]
  fromDate: string
  toDate: string
}

export interface AdvancedFilterJson {
  advancedFilters: AdvancedFilter[]
}

export interface FormErrors {
  searchPhrase?: boolean
}

export const initialFormValues: ShipmentFormValues = {
  searchPhrase: '',
  searchOperator: 'AND',
  customers: [],
  orderStatus: ACTIVE_ORDERS,
  states: SEARCHABLE_STATES,
  date: NO_DATE,
  advancedFilters: [{ type: 'service', condition: 'INCLUDE', searchTerm: '' }],
  fromDate: today().toFormat('yyyy-MM-dd'),
  toDate: today().toFormat('yyyy-MM-dd')
}
